import script from "./settingsMixin.vue?vue&type=script&lang=js"
export * from "./settingsMixin.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__